import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { Button } from '@/components/atoms';
import { ApiError } from '@/services/api';
import { authApi } from '@/services/auth';
import { useAuth } from '@/store/useAuth';
import { useBrand } from '@/store/useBrand';

import styles from './Login.module.css';

// Politica unica do produto, igual a do cadastro e a do backend
// (`auth.py`, `signup.py`). Eram tres numeros diferentes espalhados.
const MIN_SENHA = 8;

export function TrocarSenha() {
  const navigate = useNavigate();
  const clearMustChange = useAuth((s) => s.clearMustChange);
  const brand = useBrand((s) => s.brand);
  const [atual, setAtual] = useState('');
  const [pw, setPw] = useState('');
  const [pw2, setPw2] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    if (pw.length < MIN_SENHA) {
      setError(`A senha precisa de pelo menos ${MIN_SENHA} caracteres.`);
      return;
    }
    if (pw !== pw2) {
      setError('As senhas não coincidem.');
      return;
    }
    setLoading(true);
    try {
      await authApi.changePassword(atual, pw);
      clearMustChange();
      navigate('/', { replace: true });
    } catch (err) {
      setError(
        err instanceof ApiError
          ? err.status === 403
            ? 'Senha atual incorreta.'
            : 'Não foi possível trocar a senha.'
          : 'Erro de ligação.',
      );
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className={styles.root}>
      <form className={styles.card} onSubmit={handleSubmit}>
        <div className={styles.brand}>
          {brand.logo_url ? (
            <img className={styles.logo} src={brand.logo_url} alt={brand.name} />
          ) : (
            <>
              <span className={styles.brandMark}>{brand.name}</span>
              {brand.sub && <span className={styles.brandSub}>{brand.sub}</span>}
            </>
          )}
        </div>
        <p className={styles.tagline}>Primeiro acesso · defina a sua nova senha</p>

        <label className={styles.field}>
          <span>Senha atual</span>
          <input
            type="password"
            value={atual}
            onChange={(e) => setAtual(e.target.value)}
            autoComplete="current-password"
            autoFocus
            required
          />
        </label>

        <label className={styles.field}>
          <span>Nova senha</span>
          <input
            type="password"
            value={pw}
            onChange={(e) => setPw(e.target.value)}
            autoComplete="new-password"
            minLength={MIN_SENHA}
            aria-describedby="regra-senha"
            required
          />
          {/* A regra era descoberta ERRANDO: o operador digitava, enviava e so
              entao lia quantos caracteres faltavam. Dizer antes custa uma linha. */}
          <small id="regra-senha" className={styles.dica}>
            Mínimo de {MIN_SENHA} caracteres.
          </small>
        </label>

        <label className={styles.field}>
          <span>Confirmar senha</span>
          <input
            type="password"
            value={pw2}
            onChange={(e) => setPw2(e.target.value)}
            autoComplete="new-password"
            required
          />
        </label>

        {error && <p className={styles.error}>{error}</p>}

        <Button type="submit" loading={loading} className={styles.submit}>
          Salvar e entrar
        </Button>
      </form>
    </div>
  );
}
